import { toast } from 'sonner';
import { Toaster } from '../ui/sonner';

export const showToast = (message: string, type: string = 'info') => {
  switch (type) {
    case 'success':
      toast.success(message);
      break;
    case 'error':
      toast.error(message);
      break;
    default:
      toast.info(message);
      break;
  }
};

export const ToastContainer = () => {
  return <Toaster />;
};
